export default __webpack_public_path__ + "static/media/Group 43.86ec7663.svg";